module.exports = __webpack_public_path__ + "static/media/1POLICY47.ec920bb7.jpg";